<template>
    <div
       class="nuttrema-option-slider-item"
      :class="[ `theme-${theme}`, { 'is-active': isActive, 'is-disabled': isDisabled, 'is-future': isFuture }]"
      :ref="option.code"
      :title="isFuture ? $t('label.plan_will_be_available') : ''"
      @click="onClick">
      <slot></slot>
      <template v-if="!$slots.default">
        <div class="option__title">{{ option.name }}</div>
        <div class="option__description">{{ option.outline }}</div>
        <div class="option__price-starting" v-if="_get(option, 'data.price_starting')">
          <el-tooltip class="item" effect="dark" :content="$t('label.plan_staring_prices', { price_per_month: _get(priceStarting, 'price_per_month'), price_per_year: _get(priceStarting, 'price_per_year'), symbol: _get(priceStarting, 'symbol') })" placement="top">
            <a @mouseover="$emit('hover')">{{ $t('label.plan_staring_from', { price_per_month: _get(priceStarting, 'price_per_month'), symbol: _get(priceStarting, 'symbol') }) }}</a>
          </el-tooltip>
        </div>

<!--         <template v-for="price in priceOptions">
          <template v-if="Number(_get(price, 'price', 0)) !== 0">
            <div v-if="_get(price, 'monthly_price')" class="option__price_month">
              {{ _get(price, 'monthly_price') }}{{ _get(price, 'Currency.symbol') }} {{ $t('label.montly') }}
            </div>
            <div v-if="_get(price, 'price')" class="option__price_year">
              <strong>{{ $t('label.starting_from') }} {{ _get(price, 'price') | number-format(0) }}{{ _get(price, 'Currency.symbol') }} {{ $t('label.yearly') }}</strong>
            </div>
          </template>
          <template v-else>
            <div class="option__price_month">{{ _get(option, 'description') }}</div>
          </template>
        </template> -->

      </template>
    </div>
</template>

<script>
import { get } from 'lodash';
import Emiter from 'components/mixins/emitter';

export default {
  name: 'nuttrema-option-slider-item',
  mixins: [Emiter],
  props: {
    value: {},
    option: {
      type: Object,
      required: true,
      default: null,
    },
    selectedCurrencyID: {
      required: false,
      default: null,
    },
    selectedCurrencyCode: {
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
  },
  computed: {
    priceStarting() {
      return get(this.option, `data.price_starting.${this.selectedCurrencyCode}`);
    },
    parentValue() {
      return this.parentGroup.value;
    },
    parentGroup() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'NuttremaOptionSliderGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }
      return false;
    },
    isActive() {
      return this.value === this.parentValue;
    },
    isDisabled() {
      return this.disabled || this.parentGroup.disabled;
    },
    isFuture() {
      return get(this.option, 'status') === 'future';
    },
    // style() {
    //   const color = get(this.option, 'data.color');
    //   return {
    //     backgroundColor: `${color}`,
    //   };
    // },
  },
  methods: {
    onClick() {
      this.$nextTick(() => {
        if (!this.isDisabled && !this.isFuture) this.dispatch('NuttremaOptionSliderGroup', 'handleChange', this.value);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-option-slider-item {
    z-index: 1;
    width: 1px;
    margin: 4px;
    flex-grow: 1;
    display: flex;
    padding: 0.5em;
    margin-right: 0;
    flex-basis: auto;
    position: relative;
    border-radius: 8px;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    color: #fff;
    text-align: center;

    > * {
      text-align: center;
      color: #fff;
    }

    .option__title {
      font-weight: 600;
      font-size: 1.25em;
    }

    .option__description {
      font-size: 0.95em;
    }

    .option__price-starting {
      right: 1em;
      top: -0.65em;
      height: 1.5em;
      min-width: 3em;
      font-weight: 600;
      padding: 0 0.75em;
      position: absolute;
      font-size: 0.85rem;
      line-height: 1.35;
      border-radius: 0.75em;
      background-color: #a5acb3;
      text-shadow: 0 -1px 0 rgba(0,0,0, 0.25);
      > * {
        color: #fff;
      }
    }

    .option__price_month {
      font-weight: 500;
      font-size: 1.15em;
    }

    &:last-child {
      margin-right: 4px;
    }

    &:hover, &:focus, &:active {
      cursor: pointer;
      background-color: rgba(#fff, 0.25);
    }

    &.is-active {
      .option__price-starting {
        background-color: #9C27B0;
      }
      &:hover, &:focus, &:active {
        cursor: inherit;
        background-color: transparent;
      }
    }

    &.is-future {
      background-color: rgba(0,0,0, 0.25);
      > * {
        color: #009692;
      }
      &:hover, &:focus, &:active {
        cursor: inherit;
      }
    }

    &.theme-sub-group {
      > * {
        text-align: center;
        color: #fff;
      }
      &.is-active {
        > * {
          color: #009692;
          font-weight: 600;
        }
        &:hover, &:focus, &:active {
          cursor: inherit;
          background-color: transparent;
        }
      }
    }

    &.theme-sub-group-gray {
      > * {
        text-align: center;
        color: #607d8b;
      }

      &:hover, &:focus, &:active {
        cursor: pointer;
        background-color: rgba(#607d8b, 0.25);
      }

      &.is-active {
        background-color: rgba(#607d8b, 0.25);
        > * {
          color: #607d8b;
          font-weight: 600;
        }
        &:hover, &:focus, &:active {
          cursor: inherit;
          background-color: transparent;
        }
      }
    }

    &.theme-gray {
      > * {
        text-align: center;
        color: #607d8b;
      }

      &:hover, &:focus, &:active {
        background-color: rgba(#607d8b, 0.25);
      }

      &.is-active {
        > * {
          color: #fff;
          font-weight: 600;
        }
        &:hover, &:focus, &:active {
          cursor: inherit;
          background-color: transparent;
        }
      }
    }

    &.theme-topography, .nuttrema-theme-professional-topography & {

      // background-color: rgba(0,0,0, 0.5);
      background-color: rgba(0,0,0, 0.075);

      > * {
        color: #465568;
      }

      &.is-active {
        background-color: transparent;
        > * {
          color: #fff;
        }
      }

      &.is-future {
        background-color: transparent;
        > * {
          color: rgba(#607d8b, 0.5);
        }
        &:hover, &:focus, &:active {
          cursor: inherit;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/switch/nuttrema-option-slider-item.vue